import React, { useEffect, useState } from "react";
import { api, fmtMoney } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { toast } from "sonner";

export default function PayoutsAdmin() {
  const [items, setItems] = useState([]);
  const [tab, setTab] = useState("processing");

  const load = async (t) => {
    const { data } = await api.get(`/admin/payouts?status=${t}`);
    setItems(data);
  };
  useEffect(() => { load(tab); }, [tab]);

  const approve = async (id) => {
    try {
      await api.post(`/admin/payouts/${id}/approve`);
      toast.success("Payout marked paid");
      load(tab);
    } catch (e) {
      toast.error("Couldn't approve");
    }
  };

  const reject = async (id) => {
    try {
      await api.post(`/admin/payouts/${id}/reject`);
      toast.success("Payout rejected and funds restored");
      load(tab);
    } catch (e) {
      toast.error("Couldn't reject");
    }
  };

  return (
    <div data-testid="adm-payouts-page">
      <PageHeader eyebrow="Payouts" title="Cashback payouts" subtitle="Review user payout requests and mark complete." />

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="mb-6">
          <TabsTrigger value="processing">Processing</TabsTrigger>
          <TabsTrigger value="paid">Paid</TabsTrigger>
          <TabsTrigger value="rejected">Rejected</TabsTrigger>
          <TabsTrigger value="all">All</TabsTrigger>
        </TabsList>
        <TabsContent value={tab}>
          <Card className="border-gray-200 shadow-none rounded-2xl">
            <CardContent className="p-0">
              <table className="w-full text-sm">
                <thead className="border-b border-gray-200 bg-gray-50">
                  <tr className="text-left">
                    <th className="px-5 py-3 font-semibold">User</th>
                    <th className="px-5 py-3 font-semibold">Method</th>
                    <th className="px-5 py-3 font-semibold">Amount</th>
                    <th className="px-5 py-3 font-semibold">Status</th>
                    <th className="px-5 py-3 font-semibold">Requested</th>
                    <th className="px-5 py-3 font-semibold w-44">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((p) => (
                    <tr key={p.id} className="border-b border-gray-100" data-testid={`payout-${p.id}`}>
                      <td className="px-5 py-3 font-medium">{p.user?.name}<span className="text-gray-400 ml-2">{p.user?.email}</span></td>
                      <td className="px-5 py-3 capitalize">{p.method}</td>
                      <td className="px-5 py-3 font-semibold">{fmtMoney(p.amount)}</td>
                      <td className="px-5 py-3"><Badge variant="outline">{p.status}</Badge></td>
                      <td className="px-5 py-3 text-gray-500">{new Date(p.created_at).toLocaleDateString()}</td>
                      <td className="px-5 py-3 flex gap-2">
                        {p.status === "processing" && (
                          <>
                            <Button size="sm" onClick={() => approve(p.id)} className="bg-emerald-700 hover:bg-emerald-800 text-white">Mark paid</Button>
                            <Button size="sm" variant="outline" onClick={() => reject(p.id)}>Reject</Button>
                          </>
                        )}
                      </td>
                    </tr>
                  ))}
                  {items.length === 0 && <tr><td colSpan="6" className="px-5 py-12 text-center text-gray-500">No payouts in this view.</td></tr>}
                </tbody>
              </table>
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
}
